import { t } from "i18next";
import { ButtonText } from "../Button";
import { useAppSelector } from "src/common/state/hooks";
import { allTeamSelector } from "../../../features/team/state/teamSlice";
import { getCurrentOrganization } from "../../../features/profile/state/profileSlice";
import { useEditButtonFlash } from "./useEditButtonFlash";

type ListItemProps = {
  title: string;
  currUserId?: number;
  children?: React.ReactNode;
  disabled?: boolean;
  setDisabled: (arg: boolean) => void;
  setValueFct?: unknown;
  hidden?: boolean;
  customButton?: React.ReactNode;
  onPickImage?: () => void;
};

const OrganizationInputStyle = ({
  title,
  currUserId,
  disabled,
  hidden = false,
  setDisabled,
  children,
  customButton,
  onPickImage,
}: ListItemProps) => {
  const { flashClassName, flash } = useEditButtonFlash();
  const team = useAppSelector(allTeamSelector);
  const org = useAppSelector(getCurrentOrganization);

  const admin = team.find((u) => Number(u.id) === Number(org?.admin?.id));
  const adminId = Number(admin?.id);

  const DefaultButton = () => {
    if (Number(currUserId) === Number(adminId) && !hidden) {
      return (
        <ButtonText
          type="button"
          text={t("general.edit")}
          className={flashClassName}
          onClick={() => {
            if (isLogoField) {
              onPickImage?.();
            } else {
              setDisabled(!disabled);
            }
          }}
        />
      );
    } else if (
      Number(currUserId) !== Number(adminId) &&
      title === t("pages.profile.organization.adminEmail")
    ) {
      return (
        <a href={`mailto:${admin?.email}`}>
          <ButtonText type="button" text={t("pages.profile.organization.contactAdmin")} />
        </a>
      );
    } else {
      return <></>;
    }
  };

  const isLogoField = title === t("pages.profile.organization.companyLogo");
  const editLocked =
    !customButton && Number(currUserId) === Number(adminId) && !hidden && disabled !== false;
  return (
    <div className="w-full flex flex-col sm:flex-row items-center py-2 px-2 xl:py-3 xl:px-4 border-t border-gray-300">
      <p className="w-full sm:w-1/3 text-sm text-center sm:text-left">{title}</p>
      <div className="contents" onClickCapture={editLocked ? flash : undefined}>
        {children}
      </div>
      <div className="flex grow justify-end">{customButton || <DefaultButton />}</div>
    </div>
  );
};

export default OrganizationInputStyle;
